import { useContext, useEffect, useRef, useState } from "react";
import loaderContext from "../../context/loader/LoaderContext";
import studyviewerContext from "../../context/studyviewer/StudyviewerContext";
import userContext from "../../context/users/UserContext";
import ViewportContext from "../../context/studyviewer/ViewportContext";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import toastContext from "../../context/toast/ToastContext";
import { initialize, purgeCache, getAugToolGroup } from "./helpers/CornerstoneService";
import {
  resetVOILUTRange,
  setVOILUTRange,
} from "./helpers/WindowLevelUtility";

import {
  setInvert,
  FlipHorizontally,
  FlipVertically,
  loadAIImages,
  resizeViewport,
  performResize,
  getViewport,
  setToolOnActiveMPRViewport,
  setToolOnActiveViewport,
} from "./helpers/CornerstoneViewportService";
import AlertSuccessModal from "../../components/AlertSuccessModal/AlertSuccessModal";
import ConfirmAlertModal from "../../components/ConfirmAlertModal/ConfirmAlertModal";
import CommunicationModal from "../Communication/CommunicationModal";
import TopBar from "./Components/TopBar";
import Annotations from "../Annotations/Annotations";
import ThumbnailList from "./Components/Thumbnail/ThumbnailList";
import NewReport from "../Report/NewReport";
import ViewportLayout from "./Components/Viewport/ViewportLayout";
import {
  LATERAL_VIEW_MODALITY_LIST,
  USERTYPES,
  SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST,
  showPathologyForModalities,
  NONXRAYMODALITIES,
  DEFAULT_TOOL,
  NonAuthRoutes,
} from "../../constants/Constants";
import { isMobile } from "react-device-detect";
import {
  useParams,
  useSearchParams,
} from "react-router-dom";
import themeContext from "../../context/theme/ThemeContext";
import ContextMenu from "./helpers/ContextMenu";
import ThumbnailContext from "../../context/studyviewer/ThumbnailContext";
import Impressions from "./Components/Overlays/Impressions";
import NotAllowed from "../../components/NotAllowed";
import { logAmplitudeEventWithUsernameAndRole } from "../../helpers/Amplitude";
import RSNAModal from "../Report/components/ReportModals/RSNAModal/RSNAModal";
import SubmitTick from "./Components/SubmitTick/SubmitTick";
import SuspectIcon from "./Components/SuspectIcon/SuspectIcon";
import { t } from "i18next";
import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";
import ViewerStartToast from "../../components/Toast/ViewerStartToast";
import MobileViewer from "./MobileViewer";
import ShortcutKeyModal from "./Components/ShortcutKeyModal/ShortcutKeyModal";
import SeriesStackScrollMouseWheelTool from "./helpers/SeriesStackScrollMouseWheelTool";
import MobileViewerContext from "../../context/studyviewer/MobileViewerContext"; // adjust path if needed

const Viewer = (props) => {
  var gf_location = "";
  const [cornerstoneInitialized, setCornerstoneInitialized] = useState(false);
  // const [showPathologyOptions, setShowPathologyOptions] = useState(
  //   (isMobile || process.env.REACT_APP_VDC_PLATFORM=="true")? false : true
  // );
  const [pathologyOptionOpened, setPathologyOptionOpened] = useState(true);
  const [documentTitle, setDocumentTitle] = useState(null);
  const [windowHeight] = useState(window.innerHeight * 0.88);
   const [initialVOIRange, setInitialVOIRange] = useState({});
   
  const { studyId } = useParams();
  const [searchParams] = useSearchParams();
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const {
    assignmentData,
    setConfirmAlertModal,
    qcData,
    fetchStudyData,
    studyData,
    studyResponseData,
    priorStudyResponseData,
    studyModality,
    keyImages,
    dataGathered,
    thumbnailLoaded,
    studyParentId,
    setMessageCount,
    messageCount,
    fetchPriorStudyData,
    priorStudyData,
    patientStudyData,
    isAccessAllowed,
    notAllowedMessage,
    firmViewerId,
    setFirmViewerId,
    autoOpenReportPanel,
    parentChildReportsObj,
    extReportRecieved,
    restrictionForVDC,
    aiProcessed,
    viewerOpacity,
    setViewerOpacity,
    showStartAlertToast,
    showStudyExpirationPopup,
    showStudyAlreadyExpiredPopup,
    isOutlineEnabled,
    isHeatMapEnabled,
    setIsOutlineEnabled,
    setIsHeatMapEnabled,
    showShortcutModal,
    showPathologyOptions,
    setShowPathologyOptions,
    showTopBar,
    isLandscape,
    maskImages
  } = useContext(studyviewerContext);
  const { roles, username, privilegedFirmDoctor } =
    useContext(userContext);
  const {
    annotationData,
    activeViewportIndex,
    annotationDataAI,
    allTextToolAnnotation,
    changeLayout,
    isMPRActive,
    contextMenuOpen,
    isCompareActive,
    allowAddingTextAnnotation,
    showPriorStudyTopBar,
    imageLoadedOnViewport,
    viewportSeriesData,
    activeTool,
    setActiveTool,
    activeMPRTool,
    handleDefaultToolChange,
    setPreviousActiveTool,
    setPreviousActiveMPRTool,
    sharedViewer,
    seriesScrollCallback,
    viewportOldState,
    activeMPRViewportIndex,
    setActiveMPRTool,
    setActiveImageMaskToogle
  } = useContext(ViewportContext);
  const {
    activeThumbnailIndex,
    activeStudyId,
    setStackScrollActiveThumbnailIndex,
  } = useContext(ThumbnailContext);
  const {
    hideCommnunicationModal,
    showCommunicationModal,
    lockStudy,
    setReportMenu,
    setSeriesMenu,
    reportMenu,
    seriesMenu,
    checkIfCancelOrNot,
    getData,
    alertSuccessModal,
    confirmAlertModal,
    hideAlertSuccessModal,
    isClientReportExist,
    openRSNAModal,
    RSNAModalContent,
    setOpenRSNAModal,
    regenerateClick,
    showSubmitTick,
    showSuspectIcon,
    disableSave,
    disableSubmit,
    setDisableSave,
    setDisableSubmit,
    isWordFilePath,
    setFirmId
  } = useContext(studyReportContext);

  const [isTabFocused, setIsTabFocused] = useState(false);
  const { setSlideReportOpen } = useContext(MobileViewerContext);

  useEffect(() => {
    setFirmViewerId(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER === window.location.pathname ?-2 :searchParams.get("firmId"));
  }, []);

  useEffect(() => {
    if(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER === window.location.pathname && assignmentData.firmId !== null){
      setFirmId(assignmentData.firmId);
      setFirmViewerId(assignmentData.firmId);
    }
  }, [assignmentData.firmId]);

  useEffect(() => {
    // console.log("IS MOBILE --------- " + isMobile);
    if (messageCount > 0) {
      //setShowCommunicationModal(true);
    }
  }, [messageCount]);

  useEffect(() => {
    const handleWindowResize = () => {
      setTimeout(() => {
        resizeViewport();
      }, 300);
    };
    if (cornerstoneInitialized && dataGathered && thumbnailLoaded) {
      window.addEventListener("resize", handleWindowResize);

      return () => {
        window.removeEventListener("resize", handleWindowResize);
      };
    }
  }, [cornerstoneInitialized, thumbnailLoaded, dataGathered]);
  
  useEffect(() =>{
    document.documentElement.style.setProperty( '--viewer-smart-tag-header', isLandscape ? '14%' : '5%' );
  },[isLandscape]);

  const setSeriesStackScrollConfig = (toolGroupManager) => {
    const seriesStackScrollConfig = toolGroupManager.getToolConfiguration(SeriesStackScrollMouseWheelTool.toolName);
    const seriesStackScrollMergedConfig = { ...seriesStackScrollConfig.configuration, seriesScrollCallback };
    toolGroupManager.setToolConfiguration(SeriesStackScrollMouseWheelTool.toolName,seriesStackScrollMergedConfig, true);
  }

  const initializeCornerstone = async () => {
    try {
      await initialize(seriesScrollCallback);
      setCornerstoneInitialized(true);
      //const toolGroup = getAugToolGroup();
      //setSeriesStackScrollConfig(toolGroup);
    } catch (error) {
      console.log(error);
      window.alert(
        "You opened more studies than can be handled on your machine configuration and so this image could not be loaded. Please increase your machine configuration or open lesser images at a time. To view this image, please reload this window."
      );
    }
  };

  const getStudyData = async () => {
    if (!dataGathered) {
      setLoaderRunning(true);
      ref.current.continuousStart();
      await fetchStudyData(studyId, true);
    }
  };

  useEffect(() => {
    if (!isAccessAllowed) {
      ref.current.complete();
    }
  }, [isAccessAllowed]);

  useEffect(() => {
    if (dataGathered) {
      let eventProperties = {
        "STUDY ID": studyId,
      };
      logAmplitudeEventWithUsernameAndRole(
        "EVENT_BASIC_OPEN_STUDY",
        eventProperties,
        username
      );
    }
  }, [dataGathered]);

  const getPriorStudyData = async () => {
    if (!dataGathered) {
      setLoaderRunning(true);
      ref.current.continuousStart();
      await fetchPriorStudyData(studyId);
    }
  };

  const callAPIs = async () => {
    if (!cornerstoneInitialized) {
      await initializeCornerstone(0);
    }
    // const response = await userPreference();
    // if (response.status === 200) {
    //   setAdvViewerUser(response.data.data.advViewerUser);
    //   setUserPreferenceResponse(response.data.data.userPreference);
    // }
    if (props.priors) {
      await getPriorStudyData();
    } else {
      await getStudyData();
    }
    setLoaderRunning(false);
    ref.current.complete();
  };

  const fetchAIImages = async () => {
    if (!props.priors && NONXRAYMODALITIES.includes(studyModality)) {
      studyData.heatmapStacks.forEach(async (data) => {
        await loadAIImages(data.imageIds);
      });
      studyData.outlineStacks.forEach(async (data) => {
        await loadAIImages(data.imageIds);
      });
    } else {
      priorStudyData.forEach(async (studyData) => {
        studyData.heatmapStacks.forEach(async (data) => {
          if (NONXRAYMODALITIES.includes(data.modality))
            await loadAIImages(data.imageIds);
        });
        studyData.outlineStacks.forEach(async (data) => {
          if (NONXRAYMODALITIES.includes(data.modality))
            await loadAIImages(data.imageIds);
        });
      });
    }
  };

  const setAIPreference = () => {
    if(props.priors){
      if(priorStudyResponseData !== null){
        setIsHeatMapEnabled(priorStudyResponseData.heatMap);
        setIsOutlineEnabled(priorStudyResponseData.outline);
      }
    }else{
      if (studyResponseData != null) {
        setIsHeatMapEnabled(studyResponseData.heatMap);
        setIsOutlineEnabled(studyResponseData.outline);
      }
    }
  };

  useEffect(() => {
    if (
      thumbnailLoaded &&
      allowAddingTextAnnotation &&
      (SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(studyModality) ||
        (props.priors &&
          SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(studyModality))) &&
      imageLoadedOnViewport
    ) {
      setTimeout(() => {
        setAIPreference();
      }, 1500);
    }
  }, [thumbnailLoaded, allowAddingTextAnnotation, imageLoadedOnViewport]);

  useEffect(() => {
    if (thumbnailLoaded && !isMobile && !sharedViewer) {
      fetchAIImages();
    }
  }, [thumbnailLoaded]);

  useEffect(() => {
    if (roles.length != 0 && (roles[0].includes(USERTYPES.FIRMDOCTOR) && !privilegedFirmDoctor)) {
      setShowPathologyOptions(false);
    }
    if (
      roles.length !== 0 &&
      studyParentId !== null &&
      dataGathered &&
      isClientReportExist !== null
    ) {
      if (!roles[0].includes(USERTYPES.FIRMDOCTOR) || privilegedFirmDoctor ) {
       
        if(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER === window.location.pathname && firmViewerId !== null && firmViewerId !== -2){
          getData(false);
        }else if(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER !== window.location.pathname){
          getData(false);
        }
      }
    }
  }, [roles, studyParentId, dataGathered, isClientReportExist, firmViewerId]);

  useEffect(() => {
    // if (!authenticated) {
    //   loadByUsername();
    // }
    // if(!cornerstoneInitialized) {
    //   initializeCornerstone();
    // }
    // if (props.priors) {
    //   getPriorStudyData();
    // } else {
    //   getStudyData();
    // }
    if (firmViewerId !== -1) {
      callAPIs();
    }
  }, [firmViewerId]);

  useEffect(() => {
    if (
      restrictionForVDC !== null &&
      roles[0].includes(USERTYPES.RADIOLOGIST) &&
      (disableSave != restrictionForVDC || disableSubmit !== restrictionForVDC)
    ) {
      // console.log(
      //   "-----Handling save and submit for VDC------",
      //   restrictionForVDC
      // );
      if (isWordFilePath == false && restrictionForVDC == true) {
        setDisableSave(restrictionForVDC);
        setDisableSubmit(restrictionForVDC);
      }
    }
  }, [restrictionForVDC, disableSave, disableSubmit]);

  useEffect(() => {
    if (
      typeof patientStudyData?.patientName !== "undefined" &&
      patientStudyData?.patientName !== null
    )
      setDocumentTitle(patientStudyData?.patientName + " (DeepTek)");
  }, [patientStudyData]);

  useEffect(() => {
    if (documentTitle !== null) {
      document.title = documentTitle;
    }
  }, [documentTitle]);

  useEffect(() => {
    if (LATERAL_VIEW_MODALITY_LIST.includes(studyModality) && !isMobile) {
      changeLayout(1, 2);
    }
  }, [studyModality]);

  const openReportMenu = () => {
    setViewerOpacity(0);
    setTimeout(() => {
      setReportMenu((prevFlag) => !prevFlag);
      // setSeriesMenu(false);
    }, 100);
    setTimeout(async () => {
      await performResize();
      setViewerOpacity(1);
    }, 1000); 
  
  };

  const openSeriesMenu = () => {
    if(!isMobile){
      setViewerOpacity(0.1);
    }
    // Close Report when opening Series
    setSlideReportOpen(false);
    setTimeout(() => {
      setSeriesMenu(!seriesMenu);
      // setReportMenu(false);
    }, 100);
    setTimeout(() => {
      if(!isMobile){
        performResize();
        setViewerOpacity(1);
      }
    }, 500);
  };

  useEffect(() => {
    if(autoOpenReportPanel && imageLoadedOnViewport) {
      openReportMenu();
    }
  }, [autoOpenReportPanel, imageLoadedOnViewport])

  useEffect(() => {
   

    const handleFocus = () => {
      if(!isTabFocused && NONXRAYMODALITIES.includes(studyModality) && imageLoadedOnViewport){
        setViewerOpacity(0);
        setIsTabFocused(true);
        setTimeout( async () => {
          resizeViewport();
          setViewerOpacity(1);
        }, 500); 
      }
      // resizeViewport();
    };
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        handleFocus();
      }
    };
  
    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);
  
    return () => {
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isTabFocused, studyModality, imageLoadedOnViewport]);

  useEffect(() => {
    if (!showPathologyOptions) {
      setPathologyOptionOpened(false);
    } else {
      setTimeout(() => {
        setPathologyOptionOpened(true);
      }, 600);
    }
  }, [showPathologyOptions, cornerstoneInitialized, studyModality]);

  const onKeyPress = async (event) => {
    const { target, keyCode } = event;
    const currentViewportIndex = isMPRActive ? activeMPRViewportIndex : activeViewportIndex;

    const srcElement = event.srcElement || event.target;
    if (srcElement && srcElement.classList && srcElement.classList.contains("fr-element")) {
      return;
    }
    document.addEventListener("keydown", (event) => {
      console.log(`Key Pressed: ${event.key} | Code: ${event.keyCode}`);
    });
    // event.preventDefault();
    if(target.nodeName!=='INPUT' && target.nodeName!=='TEXTAREA' && target.nodeName!='SELECT')
    {
      switch (keyCode) {
        case 27: //ESC
          if(isMPRActive) {
            setPreviousActiveMPRTool(activeMPRTool);
            handleDefaultToolChange();
          } else {
            setPreviousActiveTool(activeTool);
            handleDefaultToolChange();
          }
          break;
        case 73: //i -- INVERT
           setInvert(activeViewportIndex);
           break;
        case 72: //h -- HORIZONTAL FLIP
          FlipHorizontally(activeViewportIndex);
           break;
        case 86: //v -- VERTICAL FLIP
          FlipVertically(activeViewportIndex);
           break;
        case 48: //NORMAL WW WC
          console.log("Pressed 0 - Checking if resetVOILUTRange() is called");
          console.log("Calling resetVOILUTRange with range:", initialVOIRange);
          console.log("activeViewportIndex:", activeViewportIndex);
          //resetVOILUTRange(activeViewportIndex,initialVOIRange,isMPRActive);
          if (isMPRActive) {
            [0, 1, 2].forEach((viewportIndex) => {
              resetVOILUTRange(viewportIndex, initialVOIRange, true);
            });
          } else {
            resetVOILUTRange(activeViewportIndex, initialVOIRange, false);
          }
          console.log("resetVOILUTRange() executed successfully");
           break;
        case 49: //CT ABDOMEN
          setVOILUTRange(currentViewportIndex, 400, 60,false,isMPRActive);
           break;
        case 50: //CT ANGIO
          setVOILUTRange(currentViewportIndex, 600, 300,false,isMPRActive);
           break;
        case 51: //CT BONE
          setVOILUTRange(currentViewportIndex, 1500, 300,false,isMPRActive);
           break;
        case 52: //CT BRAIN
          setVOILUTRange(currentViewportIndex, 80, 40,false,isMPRActive);
            break;
        case 53: //CT CHEST
          setVOILUTRange(currentViewportIndex, 400, 40,false,isMPRActive);
            break;
        case 54: //CT LUNGS
          setVOILUTRange(currentViewportIndex, 1500, -400,false,isMPRActive);
            break;     
        case 38: //UP
            const activeViewport1 = await getViewport(activeViewportIndex);
            const currentImage1 = activeViewport1.getCurrentImageIdIndex();
            
            if (currentImage1 !== 0) {
              activeViewport1.setImageIdIndex(currentImage1 - 1);
            }
             break;
        case 40: //DOWN
            const activeViewport2 = await getViewport(activeViewportIndex);
            const currentImage2 = activeViewport2.getCurrentImageIdIndex();
            if (currentImage2 !== viewportSeriesData[activeViewportIndex].stack.thumbnailImageIds.length - 1) {
              activeViewport2.setImageIdIndex(currentImage2 + 1);
            }
            break;
        case 83:
            openSeriesMenu(); 
            if (!reportMenu && activeTool !== DEFAULT_TOOL) {
              setPreviousActiveTool(activeTool);
              setActiveTool(DEFAULT_TOOL);
              break;
          }
          break;
        case 82:
          if(event.target.nodeName!=='INPUT' && (!roles[0].includes(USERTYPES.FIRMDOCTOR) || privilegedFirmDoctor))
            openReportMenu();
          break;
        case 39: //ARROW RIGHT
          if (!reportMenu) {
            if (activeThumbnailIndex === studyData?.stacks.length - 1) {
              break;
            }
            let activeThumbnailIndexNumber = Number(activeThumbnailIndex);
            setStackScrollActiveThumbnailIndex(activeThumbnailIndexNumber+1);
          }
          break;
        case 37: //ARROW LEFT
          if (!reportMenu) {
            if (activeThumbnailIndex === 0) {
              break;
            }
            setStackScrollActiveThumbnailIndex(activeThumbnailIndex - 1);
          }
          break;
        case 69: // 'e' for Elliptical
          // setActiveTool("EllipticalROI");
          // break;
          if (isMPRActive) {
            setPreviousActiveMPRTool(activeMPRTool);
            setActiveMPRTool("EllipticalROI");
            setToolOnActiveMPRViewport(activeMPRViewportIndex, "EllipticalROI", activeMPRTool, activeMPRViewportIndex);
          } else {
            setPreviousActiveTool(activeTool);
            setActiveTool("EllipticalROI");
            setToolOnActiveViewport(activeViewportIndex, "EllipticalROI", activeTool, activeViewportIndex);
          }
          break;

        case 76: // 'l' for Length
          // setActiveTool("Length");
          // break;
          if (isMPRActive) {
            setPreviousActiveMPRTool(activeMPRTool);
            setActiveMPRTool("Length");
            setToolOnActiveMPRViewport(activeMPRViewportIndex, "Length", activeMPRTool, activeMPRViewportIndex);
          } else {
            setPreviousActiveTool(activeTool);
            setActiveTool("Length");
            setToolOnActiveViewport(activeViewportIndex, "Length", activeTool, activeViewportIndex);
          }
          break;
        default:
          break;
      }
    }

  };




  useEffect(() => {
    window.addEventListener("keydown", onKeyPress);
    return () => {
      window.removeEventListener("keydown", onKeyPress);
    };
  });

  useEffect(() => {
    window.addEventListener("beforeunload", (e) => {
      // e.preventDefault();
      purgeCache();
    });

    return () => {
      window.removeEventListener("beforeunload", (e) => {
        // e.preventDefault();
        purgeCache();
      });
    };
  });

  const regenerateRSNA = (reportName) => {
    hideModal();
    if (reportName == "TUBERCULOSIS") {
      regenerateClick();
    }
  };

  const hideModal = () => {
    setOpenRSNAModal(false);
  };

  const checkForChildStudy = () => {
    if (
      activeStudyId !== "" &&
      studyParentId !== null &&
      studyParentId !== undefined
    ) {
      if (activeStudyId == studyParentId) {
        return false;
      } else {
        return true;
      }
    }
  };

  useEffect(() => {
    document.addEventListener("gesturestart", function (e) {
      e.preventDefault();
      // special hack to prevent zoom-to-tabs gesture in safari
      document.body.style.zoom = 0.99;
    });

    document.addEventListener("gesturechange", function (e) {
      e.preventDefault();
      // special hack to prevent zoom-to-tabs gesture in safari
      document.body.style.zoom = 0.99;
    });

    document.addEventListener("gestureend", function (e) {
      e.preventDefault();
      // special hack to prevent zoom-to-tabs gesture in safari
      document.body.style.zoom = 0.99;
    });
  }, []);

  return (
    <>
      {!isAccessAllowed && notAllowedMessage !== "" ? (
        <NotAllowed msg={notAllowedMessage} />
      ) : (
        <>
          {cornerstoneInitialized &&
            ((!props.priors && studyData.stacks.length !== 0) || true) && (
              <>
                {openRSNAModal && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0,
                      zIndex: 100000,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <RSNAModal
                      regenerateClick={regenerateRSNA}
                      hideModal={hideModal}
                      content={RSNAModalContent}
                      isModalOpen={openRSNAModal}
                    />
                  </div>
                )}
                {alertSuccessModal?.show && (
                  <AlertSuccessModal
                    isError={alertSuccessModal.isError}
                    isWarning={alertSuccessModal.isWarning}
                    isSuccess={alertSuccessModal.isSuccess}
                    heading={alertSuccessModal.heading}
                    description={alertSuccessModal.description}
                    hideModal={hideAlertSuccessModal}
                    isModalOpen={alertSuccessModal?.show}
                  />
                )}
                {confirmAlertModal?.show && (
                  <ConfirmAlertModal
                    isError={confirmAlertModal.isError}
                    heading={confirmAlertModal.heading}
                    isConflictPopup={confirmAlertModal.isConflictPopup}
                    description={confirmAlertModal.description}
                    hideModal={hideAlertSuccessModal}
                    isModalOpen={confirmAlertModal?.show}
                    type={confirmAlertModal.type}
                    lockStudy={lockStudy}
                    assignmentData={assignmentData}
                    checkIfCancelOrNot={checkIfCancelOrNot}
                    annotationData={annotationData}
                    annotationDataAI={annotationDataAI}
                    keyImages={keyImages}
                    activeViewportIndex={activeViewportIndex}
                    setConfirmAlertModal={setConfirmAlertModal}
                    allTextToolAnnotation={allTextToolAnnotation}
                    qcData={qcData}
                  />
                )}
                {
                  showShortcutModal && <ShortcutKeyModal isSharedStudyViewer={false}/>
                }
                {showSuspectIcon && <SuspectIcon />}
                {showSubmitTick && <SubmitTick />}
                {showCommunicationModal && !isMobile && (
                  <CommunicationModal
                    isModalOpen={showCommunicationModal}
                    hideModal={hideCommnunicationModal}
                    studyParentId={studyParentId}
                    activeStudyId={activeStudyId}
                    child={checkForChildStudy()}
                    setMessageCount={setMessageCount}
                    studylist={false}
                  />
                )}
                {/* <button onClick={toast}>toast</button> */}
                {showTopBar && (
                  <TopBar
                    showPathologyOptions={showPathologyOptions}
                    setShowPathologyOptions={setShowPathologyOptions}
                    openReport={openReportMenu}
                    openSeries={openSeriesMenu}
                    seriesMenu={seriesMenu}
                    assignmentData={assignmentData}
                    priors={props.priors}
                    restrictionForVDC={restrictionForVDC}
                  />
                )}
                {!isMobile && (
                  <div
                    id="viewport-div"
                    style={{
                      height: `${isMobile ? "85%" : viewportOldState.largeImage ? "100%" : isLandscape ? "92.5%" : "96%"}`,
                    }}
                  >
                    {(showPathologyForModalities.includes(studyModality) ||
                      showPriorStudyTopBar) && (
                      // showPathologyOptions &&
                      <div
                        className={`viewport-pathology-container ${
                          showPathologyOptions ? "smart-tag-header" : ""
                        }`}
                        style={{
                          height: showPathologyOptions ? "10%" : "0px",
                          // background: theme.palette.viewerPathologyBackground,
                        }}
                      >
                        {showPathologyOptions && pathologyOptionOpened && (
                          <Annotations
                            reportOpen={reportMenu}
                            openReport={openReportMenu}
                            openSeries={openSeriesMenu}
                            priors={props.priors}
                          />
                        )}
                      </div>
                    )}
                    <div
                      className="viewer-thumbnail-section"
                      style={{
                        height: `${showPathologyOptions ? "92%" : "100%"}`,
                      }}
                      // onTouchStart={handleTouchStart}
                      // onTouchEnd={handleTouchEnd}
                    >
                      <div
                        style={{
                          height: "100%",
                          paddingBottom: "0",
                        }}
                        className={
                          `${
                            isMobile
                              ? "first-comes mobile-sidebar-left mobile-thumbnail-list"
                              : "first-comes sidebarMenu sidebar-left"
                          }` + (seriesMenu === true ? " sidebar-open-left" : "")
                        }
                      >
                        {/* {dataGathered && ( */}
                          <ThumbnailList
                            patientName={patientStudyData?.patientName}
                            patientId={patientStudyData?.patientId}
                            studyData={studyData}
                            priorStudyData={priorStudyData}
                            priors={props.priors}
                          />
                        {/* )} */}
                      </div>
                      <div
                        className="viewer-viewport-container"
                        style={{
                          opacity: `${isMobile && seriesMenu ? "0.5" : 1}`,
                          // padding: `${isMobile ? "0" : "5px"}`,
                          width: `${
                            isMobile
                              ? "calc(100vw - 200px)"
                              : "calc(100vw - 150px)"
                          }`,
                        }}
                      >
                        <Impressions />
                        <div className="viewer-viewport-section h100">
                          <div
                            className="main-container h100 w100"
                          >
                            <div
                              style={{
                                border: `${
                                  isMPRActive || isCompareActive
                                    ? "1px solid #FFB801"
                                    : ""
                                }`,
                                borderRadius: `${
                                  isMPRActive || isCompareActive ? "10px" : ""
                                }`,
                                width: `${isMobile ? "99.9%" : "99.5%"}`,
                                margin: "0px 0.25%",
                                height: "99.5%",
                                position: "relative",
                              }}
                            >
                              {contextMenuOpen.open && (
                                <ContextMenu
                                  mouseEvt={contextMenuOpen.mouseEvt}
                                  data={contextMenuOpen.data}
                                />
                              )}
                              {/* {thumbnailLoaded && ( */}

                              <ViewportLayout priors={props.priors} initialVOI={setInitialVOIRange} />
                              {/* )} */}
                              {!isMobile &&
                                thumbnailLoaded &&
                                ((isOutlineEnabled && !props.priors) ||
                                  (isHeatMapEnabled && !props.priors) ||
                                  (props.priors &&
                                    isOutlineEnabled &&
                                    NONXRAYMODALITIES.includes(
                                      viewportSeriesData[activeViewportIndex]
                                        .modality
                                    )) ||
                                  (props.priors &&
                                    isHeatMapEnabled &&
                                    NONXRAYMODALITIES.includes(
                                      viewportSeriesData[activeViewportIndex]
                                        .modality
                                    )) ||
                                  (NONXRAYMODALITIES.includes(studyModality) &&
                                    aiProcessed >= 1)) && (
                                  <div className="viewer-outline-heatmap-container">
                                    <span className="viewer-outline-heatmap-text viewer-outline-heatmap-text-width">
                                      <CustomToolTipHost
                                        id="viewer-ai-text"
                                        content={t(
                                          "string-literals.ai-disclaimer"
                                        )}
                                      >
                                        {t("string-literals.ai-disclaimer")}
                                      </CustomToolTipHost>
                                    </span>
                                  </div>
                                )}
                              {isMPRActive && (
                                <div className="viewer-viewport-mpr-tag">
                                  {t("mpr.mpr-mode")}
                                </div>
                              )}
                              {isCompareActive && (
                                <div className="viewer-viewport-mpr-tag">
                                  {t("mpr.compare-mode")}
                                </div>
                              )}
                            </div>
                          </div>
                          {showStartAlertToast && <ViewerStartToast />}
                          <div
                            // style={{ height:  showPathologyOptions?window.innerHeight * 0.78:window.innerHeight * 0.88 }}
                            className={
                              `sidebarMenu sidebar-right modal-scroll` +
                              (reportMenu === true ? " sidebar-open" : "")
                            }
                          >
                            {/* <Report /> */}
                            <NewReport
                              modality={studyModality}
                              showPathologyOptions={showPathologyOptions}
                              customHeight={windowHeight}
                              qcData={qcData}
                              keyImages={keyImages}
                              annotationData={annotationData}
                              activeViewportIndex={activeViewportIndex}
                              assignmentData={assignmentData}
                              annotationDataAI={annotationDataAI}
                              allTextToolAnnotation={allTextToolAnnotation}
                              patientName={patientStudyData?.patientName}
                              patientId={patientStudyData?.patientId}
                              isStudyList={false}
                              parentChildReportsObj={parentChildReportsObj}
                              activeStudyId={activeStudyId}
                              studyParentId={studyParentId}
                              extReportReived={extReportRecieved}
                              showStudyExpirationPopup={
                                showStudyExpirationPopup
                              }
                              showStudyAlreadyExpiredPopup={
                                showStudyAlreadyExpiredPopup
                              }
                              firmId={firmViewerId}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {isMobile && <MobileViewer priors={props.priors} />}
              </>
            )}
        </>
      )}
    </>
  );
};

export default Viewer;
